import { z } from 'zod';

export const searchOptionLandRegisterSchema = z.object({
  idRealEstateLandRegisterEntry: z.number().nullable().default(null),
  // Blatt-zentrischer Abruf: Court/Gemarkung/Blattnummer leitet das Backend aus
  // dem Grundbuchblatt ab (kein RealEstateLandRegisterEntry nötig). Optional, damit
  // der Alt-Pfad (Spread aus LandParcelEntry) typkompatibel bleibt.
  idGrundbuchblatt: z.number().nullable().optional(),
  idFederalState: z.number().nullable().default(null),
  idCourt: z.number().nullable().default(null),
  idAdministrativeUnit: z.number().nullable().default(null),
  idFederalStateLogin: z.number().nullable().default(null),

  // Manuell eingegebenes Passwort des persönlichen Zugangs (nicht aus der DB)
  Password: z.string().default(''),

  SheetLandRegister: z.string().nullable().default(null),

  SearchCaseNumber: z.string().default(''),
  Parcel: z.string().default(''),
  LandParcel: z.string().default(''),

  StreetSearch: z.string().default(''),
  SearchTerm: z.string().default(''),

  SelectedDownload: z.string().array().default(['GB']),
});

const extendedSearchOptionLandRegisterResultSchema =
  searchOptionLandRegisterSchema.extend({
    LastName: z.string().default(''),
    FirstName: z.string().default(''),
    Birthname: z.string().default(''),
    Birthday: z.string().default(''),
  });

export type ISearchOptionLandRegister = z.infer<
  typeof searchOptionLandRegisterSchema
>;

export type ISearchOptionLandRegisterResult = z.infer<
  typeof extendedSearchOptionLandRegisterResultSchema
>;
